import { render, staticRenderFns } from "./PackageFormModal.vue?vue&type=template&id=4f8dffda"
import script from "./PackageFormModal.ts?vue&type=script&lang=ts&external"
export * from "./PackageFormModal.ts?vue&type=script&lang=ts&external"
import style0 from "./PackageFormModal.vue?vue&type=style&index=0&id=4f8dffda&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8dffda')) {
      api.createRecord('4f8dffda', component.options)
    } else {
      api.reload('4f8dffda', component.options)
    }
    module.hot.accept("./PackageFormModal.vue?vue&type=template&id=4f8dffda", function () {
      api.rerender('4f8dffda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/PackageFormModal.vue"
export default component.exports